import React, { useMemo } from "react";
import DxpPageShell from "../Common/StandaloneFormViews/DxpPageShell";
import { createDxpClickHandler } from "../../Helpers/utils";
import {
  DxpBodyText,
  DxpFooterRow,
  DxpHeading,
  DxpPrimaryButton,
} from "../dxpStandaloneUi";
import DxpRegistrationTopHeader from "../DxpRegistrationTopHeader";

const PROGRAM = "DXP";

function AlreadyRegistered({ appType }: { appType?: string }) {
  const onAction = useMemo(() => createDxpClickHandler(), []);

  return (
    <>
      <DxpRegistrationTopHeader program={PROGRAM} />

      <DxpPageShell appType={appType} requireCommonHeaders>
        <div className="dxp-confirmation-centered-shell">
          <div className="dxp-confirmation-white-card">
            <div className="dxp-confirmation-card-stack">
              <DxpHeading className="dxp-heading--fs-24">
                Welcome back!
              </DxpHeading>
              <DxpBodyText>
                You&apos;re already a registered user with the Adobe Digital
                Experience Partner Program. Click the button below to continue
                to sign-in screen.
              </DxpBodyText>
              <DxpFooterRow>
                <DxpPrimaryButton
                  label="Sign in now"
                  onPress={() => onAction({ actionType: "DXPHomePage" })}
                  variant="accent"
                  className="dxp-wizard-cta-inverse"
                />
              </DxpFooterRow>
            </div>
          </div>
        </div>
      </DxpPageShell>
    </>
  );
}

export default AlreadyRegistered;
